import { CreateBookingResponseDto } from "../../../../../Api/Model/CreateBookingResponseDto.csharp";
import { appointmentInitialState } from "./appointmentInitialState";

export const bookingResponseInitialState: CreateBookingResponseDto = {
  bookingSessionId: "",
  bookingStatus: -1,
  message: "",
  practicalInformation: "",
  practicalInformationDoctor: "",
  practicalInformationMinimumAge: "",
  videoLink: {
    title: "",
    url: "",
    additionalLinkInformation: "",
  },
  videoDescription: "",
  faq: [],
  centerSummary: "",
  centerPhoneNumber: "",
  centerAddressLine1: "",
  centerAddressLine2: "",
  booking: {
    applyForMembership: false,
    appointment: appointmentInitialState,
    personalInformation: {
      name: "",
      firstName: "",
      lastName: "",
      personalIdNumber: "",
      parentPersonalIdNumber: "",
      streetAddress: "",
      postalCode: "",
      city: "",
      emailAddress: "",
      mobileNumber: "",
    },
    notes: "",
    subscribeToNewsletter: false,
    waitlistContentId: "",
    remoteAppointmentOption: {
      label: "",
      preselected: false,
      attach: false,
      applyVidTelTimings: false,
    },
  },
};
